import React, { Component } from "react";
import {Collapse, OverlayTrigger, Popover} from "react-bootstrap";
import {map, each, cloneDeep, startCase, camelCase, filter, truncate} from "lodash";
import LightBox from "../common/LightBox";
import TextInput from "../common/TextInput";
import Upload from "../common/Upload";

class JobDetails extends Component {
  constructor(props) {
    super(props);
    const photos =
      props.requestDetails && props.requestDetails.photos
        ? cloneDeep(props.requestDetails.photos)
        : [];
    each(photos, photo => {
      photo.thumbnail = photo.large;
    });
    this.state = {
      carDetailsVisible: true,
      imageStartIndex: 0,
      uploadImageTypeErr: false,
      uploadImageSizeErr: false,
      showLightBox: false,
      photos: photos,
      requestImages: photos,
      expand: true,
      carImages: [],
      chassisNumber: ""
    };

    this.fileNameUpload = this.fileNameUpload.bind(this);
    this.imageThumbnails = this.imageThumbnails.bind(this);
  }

  fileNameUpload(e) {
    let files = [],
      fileBlob = [],
      fileImgSize = 0,
      errFileType = false,
      errFileSize = false;
    each(e.target.files, val => {
      fileImgSize = val.size;
      if (val.type == "image/png" || val.type == "image/jpeg") {
        if (fileImgSize >= 25000000) {
          errFileSize = true;
        } else {
          files.push({
            name: val.name,
            path: URL.createObjectURL(val),
            original: URL.createObjectURL(val),
            large: URL.createObjectURL(val),
            size: val.size,
            thumbnail: URL.createObjectURL(val)
          });
          val.localUniqueId = uniqid();
          val.isUploaded = false;
          val.isFailed = false;
          fileBlob.push(val);
        }
      } else {
        errFileType = true;
      }
    });

    if (this.state.carImages.length + files.length > 5) {
      files = [];
      fileBlob = [];
      this.setState({ imageMaxLimitError: true });
    } else {
      this.setState({ imageMaxLimitError: false });
    }

    this.setState({
      uploadImageTypeErr: errFileType,
      uploadImageSizeErr: errFileSize
    });

    e.target.value = null;
    // this.props.actions.uploadCarProfilePicture(fileBlob, this.props.carProfileReducer.newCarProfileData.batch_id, this.state.carImages + files.length);
    let carImages = [...this.state.carImages];
    let that = this;
    map(fileBlob, value => {
      let img = new Image();
      img.onload = function() {
        value.height = this.height;
        value.width = this.width;

        that.props.actions.getSignedURL(
          value,
          "vehicle",
          that.props.carProfileReducer.newCarProfileData.batch_id,
          data => {
            if (data) {
              that.props.actions.uploadImage(
                value,
                data.signed_request,
                data.url,
                data.imageId,
                true,
                imageId => {
                  let newImagesArray = cloneDeep(that.state.newImagesArray);
                  newImagesArray.push(imageId);
                  that.setState({ newImagesArray: newImagesArray });
                  console.log("What ssssss ", that.props.carProfileReducer);
                  that.props.actions.uploadCarProfilePictureTest(
                    value,
                    that.props.carProfileReducer.newCarProfileData.batch_id,
                    imageId,
                    true
                  );
                  if (
                    that.props.carProfileReducer.newCarProfileData.images &&
                    that.props.carProfileReducer.newCarProfileData.images
                      .length &&
                    that.props.carProfileReducer.newCarProfileData.images[0] &&
                    that.props.carProfileReducer.newCarProfileData.images[0]
                      .id == data.imageId &&
                    that.props.routeParams &&
                    that.props.routeParams.id
                  ) {
                    that.props.actions.setVehicleCoverImage(
                      data.imageId,
                      that.props.routeParams.id
                    );
                  }
                },
                () => that.uploadImageError(value)
              );
            }
          },
          () => that.uploadImageError(value),
          that.props.routeParams && that.props.routeParams.id
        );
      };

      carImages.push({
        isUploaded: false,
        isFailed: false,
        thumbnail: URL.createObjectURL(value),
        original: URL.createObjectURL(value),
        large: URL.createObjectURL(value),
        localUniqueId: value.localUniqueId,
        isCover: false
      });
      img.onerror = function() {
        // alert( "not a valid file: " + value.type);
      };
      img.src = URL.createObjectURL(value);
    });
    this.setState({
      carImages: carImages,
      uploadImageTypeErr: errFileType,
      uploadImageSizeErr: errFileSize
    });
  }

  imageThumbnails(imageArray) {
    return map(imageArray, (img, index) => {
      return (
        <div className="upload-box-wrapper box-shadow" key={index}>
          {img.isUploaded ? (
            <span
              className="cancel-image"
              onClick={e => {
                e.preventDefault();
                this.props.actions.deleteVehicleImage(
                  index,
                  img.id,
                  imageArray,
                  this.props.routeParams.id
                );
              }}
            >
              <i className="mdi mdi-close" />
            </span>
          ) : (
            ""
          )}
          <img
            src={
              img.isFailed
                ? `${imageBasePath}/images/warning.png`
                : img.thumbnail
            }
            onClick={() => {
              this.setState({ showModal: true, imageStartIndex: index });
            }}
          />
          {!img.isUploaded ? (
            <div>
              <img
                className="img-loader-on-upload"
                src={`${imageBasePath}/images/loader_white.gif`}
                alt="Upload in progress"
              />
            </div>
          ) : (
            ""
          )}
        </div>
      );
    });
  }

  componentWillReceiveProps(nextProps) {
    const photos =
      nextProps.requestDetails && nextProps.requestDetails.photos
        ? cloneDeep(nextProps.requestDetails.photos)
        : [];
    each(photos, photo => {
      photo.thumbnail = photo.large;
    });
    this.setState({
      imageStartIndex: 0,
      photos: photos,
      requestImages: photos
    });
  }

  onChassisChange(value) {
    console.log('On JobDetails chassis change ',this.props);
    this.setState({
      chassisNumber: value
    });
    this.props.chassisNumberChange(value);
  }

  render() {
    const { requestDetails } = this.props;
    let searchQuery = requestDetails && requestDetails.location ? requestDetails.location.replace(/[^a-zA-Z0-9 ,]/g, ""): "";
    if(searchQuery.match(/Unnamed/)){
        searchQuery =  requestDetails.latitude+","+ requestDetails.longitude;
    }

    const imageUploadedView = this.imageThumbnails(
      this.state.carImages ? this.state.carImages : []
    );
    console.log("The REQ DET 🥶 🥶 🥶", requestDetails);
    let photosView = undefined;
    if (
      requestDetails.serviceType != "Wash" &&
      this.state.requestImages &&
      this.state.requestImages.length > 0
    ) {
      photosView = map(this.state.requestImages, (photo, key) => {
        return (
          <li
            onClick={e => {
              e.preventDefault();
              this.setState({ showLightBox: true, imageStartIndex: key });
              this.setState({
                photos: this.state.requestImages,
                showLightBox: true,
                imageStartIndex: 0
              });
            }}
            key={key}
          >
            <img src={photo.small} alt="" />
          </li>
        );
      });
    }

    let policeReports = filter(requestDetails.images, { type: "policereport" });
    map(policeReports, (image, key) => {
      policeReports[key].thumbnail = image.medium ? image.medium : image.small;
    });
    let registrationCard = filter(requestDetails.images, {
      type: "registrationcard"
    });
    map(registrationCard, (image, key) => {
      registrationCard[key].thumbnail = image.medium
        ? image.medium
        : image.small;
    });
    let drivingLicense = filter(requestDetails.images, {
      type: "drivinglicense"
    });
    map(drivingLicense, (image, key) => {
      drivingLicense[key].thumbnail = image.medium ? image.medium : image.small;
    });

    let chassisNumbers = filter(requestDetails.vehicles.images, {
      type: "chassisNumber"
    });


    console.log("chassisNumbers images",requestDetails)

    map(chassisNumbers, (image, key) => {
      chassisNumbers[key].thumbnail = image.medium ? image.medium : image.small;
    })
    let chassisPhotosView = undefined;

    chassisPhotosView = map(chassisNumbers, (photo, key) => {
      return (
        <li
          onClick={e => {
            e.preventDefault();
            this.setState({ showLightBox: true, imageStartIndex: key });
            this.setState({
              photos: chassisNumbers,
              showLightBox: true,
              imageStartIndex: 0
            });
          }}
          key={key}
        >
          <img src={photo.small} alt="" />
        </li>
      );
    });

    console.log("requestDetails = ", requestDetails);
    return (
      <div>
        <div className="jobDetails-head">
          {requestDetails.serviceId != 4 ? (
            <h4>{requestDetails.serviceType} Details</h4>
          ) : (
            <h4>{requestDetails.serviceType.split(" ")[0]} Details</h4>
          )}
          <span
            className={
              "status-label status-desk-view " +
              requestDetails.jobStatus.replace(/\s+/, "").toLowerCase()
            }
          >
            {startCase(camelCase(requestDetails.jobStatus))} { JSON.stringify(requestDetails.paymentstatus) === '{}' && requestDetails.jobStatus == 'Completed' ?  requestDetails.garagejobquote.finalAmount == 0 ? "| Free" :  "| UnPaid" : requestDetails.paymentstatus.name == "Pending" || requestDetails.paymentstatus.name == "Failed" || requestDetails.paymentstatus.name == "Declined" || requestDetails.paymentstatus.name == "Cancelled" ? "| UnPaid":  requestDetails.paymentstatus.name ? "| "+requestDetails.paymentstatus.name: ""}

            {requestDetails.jobStatus == 'completed' &&

              <p className="payment-status">


               {requestDetails.paymentstatus.name == "Paid" &&  ( startCase(camelCase(requestDetails.paymentstatus.method)) ) }



              </p>
            }
          </span>
        </div>
        <div className="jobDetails-content">
          <div className="jobDetails-container">
            <div className="desc-block status-mobile-view">
              <h5>Status :</h5>
              <span
                className={
                  "status-label " +
                  requestDetails.jobStatus.replace(/\s+/, "").toLowerCase()
                }
              >
                {startCase(camelCase(requestDetails.jobStatus))}
              </span>
            </div>
            <div className="desc-block width-50">
              <h5>Customer :</h5>
              <span title={requestDetails.customer} className="text-ellipsis">
                {requestDetails.customer}
              </span>
            </div>

            {requestDetails.serviceId == 4 && (
              <div className="desc-block width-50">
                <h5>QUOTE SENT :</h5>
                <span
                  title={requestDetails.quotesSent}
                  className="text-ellipsis"
                >
                  {requestDetails.quotesSent}
                </span>
              </div>
            )}
            {requestDetails.jobStatus == "waiting" ||
            requestDetails.jobStatus == "applied" ||
            requestDetails.serviceId == 4 ? (
              <div className="desc-block width-50">
                <h5>Quote Received :</h5>
                <span
                  title={requestDetails.quotesreceived}
                  className="text-ellipsis"
                >
                  {requestDetails.quotesreceived}
                </span>
              </div>
            ) : (
              <div className="desc-block width-50">
                <h5>Quote Sent :</h5>
                <span
                  title={requestDetails.quotesSent}
                  className="text-ellipsis"
                >
                  {requestDetails.quotesSent}
                </span>
              </div>
            )}

            <div className="desc-block width-50">
              <h5>Location :</h5>
              <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Popover className="location-popover"  positionLeft={100} > {requestDetails.location}</Popover>}>
                <span className="location-text">
                  {requestDetails.location}
                </span>
              </OverlayTrigger>

              <a href={`https://www.google.com/maps/search/?api=1&query=${searchQuery}`} className="blue-text" target="_blank">Get direction</a>
            </div>
            {requestDetails.serviceId != 4 && (
              <div className="desc-block">
                <h5>Job Details :</h5>
                <span>{requestDetails.jobDetails}</span>
              </div>
            )}
            {requestDetails.serviceType != "Wash" &&
              requestDetails.serviceId != 4 && (
                <div className="desc-block">
                  <h5>Photos :</h5>
                  {this.state.photos && this.state.photos.length > 0 ? (
                    <ul className="photoList">{photosView}</ul>
                  ) : (
                    <p>Not uploaded</p>
                  )}
                </div>
              )}

          </div>
          {requestDetails.carProfileAvailable && (
            <div className="accordian-holder">
              <div className="jobSlider-accordion border-top">
                <h4
                  onClick={() =>
                    this.setState({
                      carDetailsVisible: !this.state.carDetailsVisible
                    })
                  }
                >
                  Car Details{" "}
                  <i
                    className={
                      this.state.carDetailsVisible
                        ? "mdi mdi-chevron-up pull-right"
                        : "mdi mdi-chevron-down pull-right"
                    }
                  />
                </h4>
                <Collapse in={this.state.carDetailsVisible}>
                  <div>
                    <div className="desc-block width-50">
                      <h5>Car Profile:</h5>
                      <span className="text-ellipsis">
                        {requestDetails.carProfile}
                      </span>
                    </div>
                    <div className="desc-block width-50">
                      <h5>Plate No:</h5>
                      <span className="text-ellipsis">
                        {requestDetails.plateNo}
                      </span>
                    </div>
                    <div className="desc-block width-50">
                      <h5>Make:</h5>
                      <span className="text-ellipsis">
                        {requestDetails.carmake}
                      </span>
                    </div>
                    <div className="desc-block width-50">
                      <h5>Model:</h5>
                      <span className="text-ellipsis">
                        {requestDetails.carmodel}
                      </span>
                    </div>
                    <div className="desc-block width-50">
                      <h5>Year:</h5>
                      <span className="text-ellipsis">
                        {requestDetails.year}
                      </span>
                    </div>
                    <div className="desc-block width-50">
                      <h5>Insurance Provider:</h5>
                      <span className="text-ellipsis">
                        {requestDetails.insuraceProvider}
                      </span>
                    </div>
                    <div className="desc-block width-50">
                      <h5>Chassis Number</h5>
                      {(requestDetails.chassisNumber || this.props.noeditchassis) ? (
                        <span className="text-ellipsis">
                          {requestDetails.chassisNumber}
                        </span>
                      ) : (
                        <div className="row car-profile">
                          <div className="col-md-12 padLeft0">
                            <TextInput
                              //showValidationError={this.errors['chassis_number']}
                              label="Chassis Number"
                              name="chassis_number"
                              type="text"
                              validationError=""
                              value={this.state.chassisNumber}
                              onChange={this.onChassisChange.bind(this)}
                            />
                            <label
                              style={{
                                cursor: "pointer",
                                fontFamily: "Century Gothic",
                                fontSize: "1.2rem",
                                lineHeight: "1.34em",
                                color: "#717982",
                                paddingTop: "0.34em",
                                position: "relative",
                                bottom: "2.5em"
                              }}
                            >
                              The Chassis Number can be found on the Vehicle
                              Registration Certificate (VRC)
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="desc-block width-50">

                      {chassisPhotosView ? (
                        <ul className="photoList">{chassisPhotosView}</ul>
                      ) : (
                        <p>Not uploaded</p>
                      )}
                    </div>
                    <div className="desc-block width-50">
                      <h5>Policy No:</h5>
                      <span className="text-ellipsis">
                        {requestDetails.policyNo}
                      </span>
                    </div>
                    {requestDetails.vehicles && (
                      <div className="desc-block width-50">
                        <h5>Emirate:</h5>
                        <span className="text-ellipsis">
                          {requestDetails.vehicles.state
                            ? requestDetails.vehicles.state
                            : "-"}
                        </span>
                      </div>
                    )}
                  </div>
                </Collapse>
              </div>
            </div>
          )}
          {requestDetails.repairreason == "accident" ? (
            <div className="jobSlider-accordion">
              <h4 onClick={() => this.setState({ expand: !this.state.expand })}>
                Accident Details{" "}
                <i
                  className={
                    this.state.expand
                      ? "mdi mdi-chevron-up pull-right"
                      : "mdi mdi-chevron-down pull-right"
                  }
                />
              </h4>
              <Collapse in={this.state.expand}>
                <div>
                  {policeReports.length ? (
                    <div className="desc-block accident-details">
                      <h5 className="link-title">Police Report:</h5>
                      <a
                        onClick={() => {
                          if (
                            policeReports[0] &&
                            policeReports[0].medium &&
                            policeReports[0].medium.split(".") &&
                            policeReports[0].medium
                              .split(".")
                              .pop()
                              .toLowerCase() == "pdf"
                          ) {
                            window.open(policeReports[0].original, "_blank");
                          } else if (
                            policeReports[0] &&
                            policeReports[0].medium &&
                            policeReports[0].medium.split(".") &&
                            (policeReports[0].medium
                              .split(".")
                              .pop()
                              .toLowerCase() == "jpg" ||
                              policeReports[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "jpeg" ||
                              policeReports[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "png" ||
                              policeReports[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "heic")
                          ) {
                            this.setState({
                              photos: policeReports,
                              showLightBox: true,
                              imageStartIndex: 0
                            });
                          }
                        }}
                      >
                        View
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                  {drivingLicense.length ? (
                    <div className="desc-block accident-details">
                      <h5 className="link-title">Driving Licence:</h5>
                      <a
                        onClick={() => {
                          if (
                            drivingLicense[0] &&
                            drivingLicense[0].medium &&
                            drivingLicense[0].medium.split(".") &&
                            drivingLicense[0].medium
                              .split(".")
                              .pop()
                              .toLowerCase() == "pdf"
                          ) {
                            window.open(drivingLicense[0].original, "_blank");
                          } else if (
                            drivingLicense[0] &&
                            drivingLicense[0].medium &&
                            drivingLicense[0].medium.split(".") &&
                            (drivingLicense[0].medium
                              .split(".")
                              .pop()
                              .toLowerCase() == "jpg" ||
                              drivingLicense[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "jpeg" ||
                              drivingLicense[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "png" ||
                              drivingLicense[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "heic")
                          ) {
                            this.setState({
                              photos: drivingLicense,
                              showLightBox: true,
                              imageStartIndex: 0
                            });
                          }
                        }}
                      >
                        View
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                  {registrationCard.length ? (
                    <div className="desc-block accident-details">
                      <h5 className="link-title">Registration Card:</h5>
                      <a
                        onClick={() => {
                          if (
                            registrationCard[0] &&
                            registrationCard[0].medium &&
                            registrationCard[0].medium.split(".") &&
                            registrationCard[0].medium
                              .split(".")
                              .pop()
                              .toLowerCase() == "pdf"
                          ) {
                            window.open(registrationCard[0].original, "_blank");
                          } else if (
                            registrationCard[0] &&
                            registrationCard[0].medium &&
                            registrationCard[0].medium.split(".") &&
                            (registrationCard[0].medium
                              .split(".")
                              .pop()
                              .toLowerCase() == "jpg" ||
                              registrationCard[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "jpeg" ||
                              registrationCard[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "png" ||
                              registrationCard[0].medium
                                .split(".")
                                .pop()
                                .toLowerCase() == "heic")
                          ) {
                            this.setState({
                              photos: registrationCard,
                              showLightBox: true,
                              imageStartIndex: 0
                            });
                          }
                        }}
                      >
                        View
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Collapse>
            </div>
          ) : (
            ""
          )}
        </div>
        {this.state.photos && this.state.photos.length > 0 ? (
          <LightBox
            showUploadIcon={false}
            actions={this.props.actions}
            images={this.state.photos}
            imageStartIndex={this.state.imageStartIndex}
            showModal={this.state.showLightBox}
            isEditable={false}
            closeModal={() => {
              this.setState({ showLightBox: false });
            }}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default JobDetails;



// WEBPACK FOOTER //
// ./src/components/JobSliderView/JobDetails.jsx